module.exports = __webpack_public_path__ + "static/media/принцип-роботи-зерносушарки-інпрофіт.e64a7c8a.jpg";